<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fhcccr/tc-custom/9781631950575.jpg?1737676980663" alt="This image is the cover for the book BAD (Begin Again Differently)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">BAD (Begin Again Differently)
      </h1>
      <p class="bookDescription body article font2">
        <b>“Claudette inspires you to fail into your success by transforming old patterns within yourself . . . to reach new levels in business or personal endeavors.” —Sabrenay Brandon, YES INC. team member</b><br/><br/><i>BAD (Begin Again Differently)</i> is an inspiring guide to starting over again after suffering a major loss. Claudette Yarbrough empowers readers to use the 7 Smart Processes that led her to “restart” her nonprofit after she lost her annual four million dollar contract after eighteen years. Claudette teaches readers how to make a comeback when they acknowledge and embrace their failure. In <i>BAD (Begin Again Differently)</i> readers learn:How to embrace the power of believing againHow to find their organization’s new “why” for existingThe value of over-communicatingHow to find the decisiveness needed to make good decisionsHow to cultivate rock stars for their teamHow to use the power of motivating themselves to get back on the right track<br/><br/>Any thoughts of starting over can seem like a hill that is too high to climb, but just because you’ve lost a lot doesn’t mean you have to be lost. If you want to restart, <i>BAD</i> will be your essential guide to navigating the changes needed to triumph.<br/><br/><b>“An inspirational reflection and pragmatic roadmap that is useful for anyone looking for a way to recover from a significant setback.” —Matthew J. Pepper, EdD, coauthor of <i>Leading Schools During Crisis</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claudette Yarbrough
      </h2>
      
      <p class="authorDescription body article"><B>Claudette Yarbrough</B> is an educational leader who helps other educational leaders succeed. After running a successful charter school for 18 years, she continues to assist educators in becoming more effective and to make education reform become a reality that works. Claudette lives in San Antonio, Texas, with her dog, Sally.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?316dcc0e